/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable camelcase */
import { OidcConfiguration, TokenRenewMode } from '@axa-fr/react-oidc';

import { getAuthorityUrl } from './urlHelpers';

export const configurationIdentityServer: OidcConfiguration = {
    client_id: import.meta.env.VITE_APP_OIDC_CLIENT_ID!,
    redirect_uri: `${window.location.origin}/authentication/callback`,
    silent_redirect_uri: `${window.location.origin}/authentication/silent-callback`, // Optional activate silent-signin that use cookies between OIDC server and client javascript to restore the session
    scope: 'openid profile email login.umdaschgroup.com/users.read login.umdaschgroup.com/users.write login.umdaschgroup.com/users.confidential  notifications.doka.com/notifications.inbox',
    authority: getAuthorityUrl(),
    preload_user_info: true,
    token_renew_mode: TokenRenewMode.access_token_or_id_token_invalid,
};
